import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import Layout from '../../components/Layout/index';
import HeroBanner from '../../components/HeroBanner';
import CTABanner from '../../components/CTABanner';
import Button from '../../components/Button';

import ParticipantsCounterSection from './components/ParticipantsCounterSection';
import ChartSection from './components/ChartSection';
import ProgramFindingsSection from './components/ProgramFindingsSection';
import ImprovementProgramInfoGraphicsSection from './components/ImprovementProgramInfoGraphicsSection';
import ListSection from './components/ListSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import ForumsSection from './components/ForumsSection';

import './style.scss';

const WorkAndAchievementsPage = () => {
  return (
    <Layout pageTitle="Councils' Work and Activities">
      <HeroBanner
        title="Councils' Work and Activities in 2020/21"
        photo={
          <StaticImage
            className="shape shape-photo"
            src="./assets/hero-photo-work-activities.png"
            layout="fixed"
            width={738}
            alt="The Professional Standards Authority staff, Celine De Sousa"
            quality={100}
          />
        }
      >
        <p>
          The 2020/21 Annual Report period saw 17 schemes in force nationally, and membership growth to 86,089.
          Associations' Professional Standards Improvement Program reports were analysed by the Councils informing key insights within this
          Annual Report. Other activities include case studies below, and the Councils Professional Standards Forums.
        </p>

        <Button color="primary" label="Read more about this chapter" icon="link" annualReportPage={33} />
      </HeroBanner>

      <ParticipantsCounterSection />
      <ChartSection />
      <ProgramFindingsSection />
      <ImprovementProgramInfoGraphicsSection />
      <ListSection />
      <CaseStudiesSection />
      <ForumsSection />

      <CTABanner
        annualReportPage={33}
        cover={<StaticImage className="cover" src="./assets/cta-cover.png" alt="Professional Standards Councils' 2020/21 Annual Report Councils work and activities chapter" width={192} />}
      />
    </Layout>
  );
};

export default WorkAndAchievementsPage;
